import { Component } from '@angular/core';
/**
 * Network Icon component declaration, responsible for displaying the icon for network in vis-type selection
 */
@Component({
  selector: 'mav-network-icon',
  templateUrl: './network-icon.component.html',
  styleUrls: ['./network-icon.component.scss']
})
export class NetworkIconComponent { }
